import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const startMission = (droneId) => {
    return handler.post(`missions/start/${droneId}`);
};
const continueMission = (droneId) => {
    return handler.put(`missions/continue/${droneId}`);
};
const endMission = (missionId) => {
    return handler.put(`missions/end/${missionId}`);
};
const getDroneMissions = (droneId, page, pageSize) => {
    return handler.get(`missions/drone/${droneId}?page=${page}&pageSize=${pageSize}`);
};
const getMissionRoutePoints = (missionId) => {
    return handler.get(`missions/${missionId}/route-points`);
};
const addDestinationPoint = (missionId, point) => {
    return handler.post(`missions/${missionId}/destination-points`, point);
};
const deleteDestinationPoint = (missionId, lat, lng) => {
    return handler.delete(`missions/${missionId}/destination-points?lat=${lat}&lng=${lng}`);
};
const downloadTrack = (missionId) => {
    return handler.getFile(`missions/${missionId}/download-track`, "GET");
};
export default {
    startMission,
    continueMission,
    endMission,
    getDroneMissions,
    getMissionRoutePoints,
    addDestinationPoint,
    deleteDestinationPoint,
    downloadTrack,
};
